import React from "react";
import IconAndText from "../../../Atoms/IconAndText";
import CustomDropdown from "../../../Atoms/DropDowns/CustomDropdown";
import { useSolution } from "../../../../contexts/SolutionsContext";
import CustomTextField from "../../../Atoms/TextFields/CustomTextField";
import { CircularProgress } from "@mui/material";

const DefineSolProvider = ({ sno = 3 }) => {
  const {
    ongoingSolutionData,
    updateOngoingSolDataL2,
    validateRequiredField,
    isLoadingDropdownFields,
    lookUpValues,
  } = useSolution();

  const handleDocUrlChange = (e) => {
    const value = e.target.value;
    updateOngoingSolDataL2("documentation_url", value);
    validateRequiredField("documentation_url", value);
  };

  return (
    <article className="define-sol-provider mb-5">
      <div id="sol-provider-id" className="mb-2">
        <IconAndText
          text="Define Provider"
          clsNames="mas-icon-txt mb-2"
          iconBefore={<div>{sno}</div>}
        />
      </div>

      <section className="d-flex mx-wd-100 gp-x-16">
        <div className="wd-50">
          <label className="mas-form-label-regular">{"Provider"}</label>
          <div className="d-flex align-items-center">
            <CustomDropdown
              selectValues={
                lookUpValues?.providers?.map((provider) => ({
                  label: provider,
                  value: provider,
                })) || []
              }
              value={ongoingSolutionData?.metadata?.[0]?.provider || ""}
              handleOnChange={(value) =>
                updateOngoingSolDataL2("provider", value)
              }
              dropdownLabel={"Select/Type to Search"}
              clsNames={"mas-multiselect-dd-primary mas-cust-dd-2"}
              disabled={isLoadingDropdownFields?.providers}
            />
            {isLoadingDropdownFields?.providers && (
              <CircularProgress
                style={{
                  width: "15px",
                  height: "15px",
                  opacity: 0.8,
                  marginLeft: "5px",
                }}
              />
            )}
          </div>
        </div>

        <div className="wd-50">
          <label className="mas-form-label-regular">
            {"Documentation URL"}
            <span className="marketplace-req-asterik">*</span>
          </label>
          <CustomTextField
            clsNames={"custom-text-field-container"}
            placeholder={"Type url"}
            value={ongoingSolutionData?.metadata?.[0]?.documentation_url || ""}
            handleOnChange={handleDocUrlChange}
          />
        </div>
      </section>
    </article>
  );
};

export default DefineSolProvider;
